import axios from 'axios'
import { getAppBaseUrl } from './api'

const BASE_URL = getAppBaseUrl()

// Track Referral Visit
export const trackReferralVisit = (referral) => async () => {
    try {
        await axios.post(BASE_URL + '/api/track-ffr-visit?ffr=' + referral)
    } catch (err) {
        console.error("Error tracking referral visit", err)
    }
}
